import React from 'react'
import ForgetPasswordWidget from './forget_password_widget'

function ForgetPassword() {
  return (
    <div>
        <ForgetPasswordWidget/>
    </div>
  )
}

export default ForgetPassword